export enum SimulatorType {
  SubsampleKabs = 'SubsampleKabs',
  SubsampleFF = 'SubsampleFF',
  SubsamplePtsd = 'SubsamplePtsd',
  SubsamplePC = 'SubsamplePC',
  SubsampleKr = 'SubsampleKr',
  SubsampleCubeTrendKabs = 'SubsampleCubeTrendKabs',
  SubsampleCubeTrendFF = 'SubsampleCubeTrendFF',
  SubsampleN = 'SubsampleN',
  UpscalingKabs = 'UpscalingKabs',
  UpscalingFF = 'UpscalingFF',
  UpscalingPC = 'UpscalingPC',
  UpscalingKr = 'UpscalingKr',
  UpscalingN = 'UpscalingN',
}
